module.exports = __webpack_public_path__ + "img/dusan.2b8f9c97.jpg";